import React, { useState, useEffect } from 'react';
import SongPlayer from './song_player.js';
import Spinner from './spinner.js';
import PixelatedInput from './pixelated_input.js';
import OvalButton from './oval_button.js';
import { getAnswerChoice, generatePastelColors, getComplementaryColor } from '../util.js';
import submit from '../assets/submit.png';

const AnimeQuiz = ({ quizQuestions, quizType, setBgColor }) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userGuess, setUserGuess] = useState('');
    const [showAnswer, setShowAnswer] = useState(false);
    const [quizCompleted, setQuizCompleted] = useState(false);
    const [numCorrect, setNumCorrect] = useState(0);
    const [showTicker, setShowTicker] = useState(false);
    const [submitButtonColor, setSubmitButtonColor] = useState(generatePastelColors(1)[0]);

    const [player, setPlayer] = useState(null);
    const [isPlaying, setPlaying] = useState(false);

    const currentQuestion = quizQuestions[currentQuestionIndex];

    function setupYoutubePlayer() {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.body.appendChild(script);
        window.onYouTubeIframeAPIReady = () => {
            const ytPlayer = new window.YT.Player('ytplayer');
            setPlayer(ytPlayer);
        };
    }

    useEffect(() => {
        setupYoutubePlayer();
    });

    const handleGuessChange = (e) => {
        setUserGuess(e.target.value);
    };

    const handleSubmitGuess = () => {
        if (showAnswer) {
            return;
        }
        setShowAnswer(true);
        if (quizType === 'multiple choice') {
            setShowTicker(true);
            setTimeout(() => {
                setShowTicker(false);
                if (userGuess === getAnswerChoice(currentQuestion.animeSong)) {
                    handleMarkAsCorrect();
                } else {
                    handleMarkAsIncorrect();
                }
            }, 4000);
        }
    };

    const handleMarkAsCorrect = () => {
        setNumCorrect((prev) => prev + 1);
        moveToNextQuestion();
    };

    const handleMarkAsIncorrect = () => {
        moveToNextQuestion();
    };

    const moveToNextQuestion = () => {
        let bgColor = generatePastelColors(1)[0];
        let complementaryColor = getComplementaryColor(bgColor);
        setBgColor(bgColor);
        setSubmitButtonColor(complementaryColor);
        setUserGuess('');
        if (currentQuestionIndex < quizQuestions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowAnswer(false);
            player.pauseVideo();
            setPlaying(false);
        } else {
            setQuizCompleted(true);
        }
    };

    if (quizCompleted) {
        return <h2>You got {numCorrect} out of {quizQuestions.length} questions right.</h2>;
    }

    return (
        <div>
            <div id="ytplayer" style={{ display: 'none' }}></div>
            {!(currentQuestion && currentQuestion.youtubeLink) &&
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}>
                <Spinner />
            </div>
            }
            {currentQuestion && currentQuestion.youtubeLink &&
                <div>
                    <h2>Question {currentQuestionIndex + 1} of {quizQuestions.length}</h2>
                    <h3>Guess the anime for this song!</h3>
                    <SongPlayer
                        youtubeUrl={currentQuestion.youtubeLink}
                        player={player}
                        isPlaying={isPlaying}
                        setPlaying={setPlaying} />
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}>
                        {currentQuestion.choices && 
                            currentQuestion.choices.map((option, index) => (
                                <div key={index}>
                                    <input
                                        type="radio"
                                        id={option}
                                        name="options"
                                        value={option}
                                        checked={userGuess === option}
                                        onChange={handleGuessChange}
                                    />
                                    <label htmlFor={option}>{option}</label>
                                </div>
                            ))
                        }
                        {currentQuestion.choices && currentQuestion.choices.length === 0 && 
                            <div style={{width:'300px'}}>
                                <PixelatedInput
                                    placeholder="Enter your guess"
                                    onEnter={handleSubmitGuess} />
                            </div>
                            
                        }
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>
                        <OvalButton
                            bgColor={submitButtonColor}
                            imageContent={submit}
                            onMouseDown={() => {}}
                            onMouseUp={handleSubmitGuess} />
                    </div>
                </div>
            }

        {showAnswer && (
            <div>
                <p>The correct anime is <strong>{currentQuestion.animeSong.anime.name}.</strong></p>
                <p>The song is <a href={currentQuestion.youtubeLink}><strong>{currentQuestion.animeSong.cleanedName}</strong></a> ({currentQuestion.animeSong.type}).</p>
                {quizType === 'free-form' &&
                    <div>
                        <button onClick={handleMarkAsCorrect}>i am otaku</button>
                        <button onClick={handleMarkAsIncorrect}>i brought shame to family</button>
                    </div>
                }
                {showTicker && <Spinner />}
            </div>
        )}
        </div>
    );
};

export default AnimeQuiz;
